var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('h3',{staticClass:"buy-title"},[_vm._v(_vm._s(_vm.title)+"\n ")]),_c('div',{staticClass:"order-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }